<template>
    <div style="margin-left: 75px;">
        <c-app-bar
            title          = "Export Dokumente"
            :categories    = "[]"
            :enable-search = "false"
        >
            <template v-slot:search>
                <v-spacer />
            </template>
        </c-app-bar>
        <div
            style  = "height: 917px; margin-right: 75px;"
        >
            <div class="lm-border pa-3 v-flex" >
                <div class="v-flex" style="width: 50%">
                    <v-form class="w-100" ref="form">
                        <v-row dense>
                            <v-col class="no-frame pr-2 col-5">
                                <f-enum-autocomplete
                                    v-model = "customer"
                                    label   = "Kunde"
                                    module  = "msd"
                                    type    = "limCustomer"
                                    class   = "mb-2"
                                    clearable
                                    :rules         = "[ customerRequiredRule ]"
                                    autocomplete   = "off"
                                    autocorrect    = "off"
                                    autocapitalize = "off"
                                    spellcheck     = "false"
                                />
                            </v-col>

                            <v-col class="no-frame pl-2 pr-2 col-3">
                                <v-select
                                    :items  = "types"
                                    label   = "Dokumententyp"
                                    :rules  = "[ customerRequiredRule ]"
                                    v-model = "doctype"
                                />
                            </v-col>

                            <v-col class="no-frame pl-2 pr-2 col-2">
                                <f-date-picker
                                    label   = "inc.docexport.interval.from"
                                    :time   = "false"
                                    :rules  = "[ customerRequiredRule ]"
                                    v-model = "interval.from"
                                />
                            </v-col>
                            <v-col class="no-frame pl-2 col-2">
                                <f-date-picker
                                    label   = "inc.docexport.interval.to"
                                    :time   = "false"
                                    :rules  = "[ customerRequiredRule ]"
                                    v-model = "interval.to"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="no-frame">
                        </v-row>
                    </v-form>
                </div>
                <div class="v-flex">
                    <div class="primary mt-1 ml-2 tool-button">
                        <a @click="onValidate">
                            <div class="primary white--text pl-3 pr-3 pt-1 pb-1 tool-button">
                                Prüfen
                            </div>
                        </a>
                    </div>
                    <div class="primary mt-1 ml-2 tool-button" v-if="documents.filtered">
                        <a @click="onExport">
                            <div class="primary white--text pl-3 pr-3 pt-1 pb-1 tool-button">
                                Download
                            </div>
                        </a>
                    </div>
                </div>
                <v-spacer />
                <div v-if="doctype === 'GBU'">
                    <v-select
                        v-model="gbuSelection"
                        :items="gbuTypes"
                        label="GBU Dokumente"
                        multiple
                        hide-details
                        class="mt-0 pt-2"
                        style="max-width: 300px"
                    >
                        <template v-slot:selection="{ item, index }">
                            <span v-if="index === 1">
                                {{ item }}
                            </span>
                            <span v-if="index === 1" class="grey--text text-caption ml-2">
                               (+{{ gbuSelection.length - 1 }} weitere)
                            </span>
                        </template>
                    </v-select>
                </div>
                <div>
                    <!-- Search criteria input -->
                    <div class=" ml-3" v-if="documents.all">
                        <v-text-field
                            outlined
                            hide-details
                            dense
                            v-model="search"
                            clearable
                            clear-icon="mdi-close-circle"
                            append-icon="mdi-eye"

                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            style="width: 250px; padding-top: 0"
                        />
                    </div>
                    <!-- Search criteria input -->
                </div>
            </div>


            <div class="v-flex h-100 mt-2" style="position:relative;">
                <v-progress-linear
                    v-if="exporting"
                    style="position: absolute; top: -7px"
                    indeterminate
                    color="primary"
                    height="6"
                />
                <div class="w-50 lm-border pa-3 h-100 mr-2">
                    <c-column-header
                        v-if = "documents.all"
                        :label="'Dokumente - ' + doctype"
                        class="primary"
                    >
                        <template v-slot:filter>
                            <div style="margin-top: -2px">
                                <c-toolbar-button
                                    color  = "white"
                                    size   = "22"
                                    icon   = "mdi-arrow-expand-vertical"
                                    @click = "onExpand"
                                    tooltip = "alle Ordner öffnen"
                                />
                            </div>
                        </template>
                    </c-column-header>
                    <v-treeview
                        v-if          = "documents.filtered"
                        :items        = "documents.filtered"
                        item-children = "entries"
                        item-key      = "key"
                        :open.sync    = "open"
                        hoverable
                        dense
                        style="max-height: calc(100% - 34px);  overflow-y: scroll"
                        ref="treeview"
                    >
                        <template v-slot:label="{ item, open }">
                            <div class="no-frame w-100">
                                <v-card  v-if="!item.filename"  flat @click = "onUnit(item)">
                                    <v-row class="no-frame" >
                                        <v-col class="no-frame table-text" style="width: 25px; max-width: 25px">
                                            <v-icon
                                                size = "20"
                                                color="primary"
                                            >
                                                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                                            </v-icon>
                                        </v-col>
                                        <v-col class="no-frame table-text col-2">
                                            {{ item.fabricNo}}
                                        </v-col>
                                        <v-col class="no-frame table-text col-4">
                                            {{ item.zip}} {{ item.city}}
                                        </v-col>
                                        <v-col class="no-frame table-text">
                                            {{ item.street}}
                                        </v-col>
                                        <v-col class="no-frame table-text col-1" v-if="isMaintenance">
                                            {{ item.current}} von {{ item.count}}
                                        </v-col>
                                    </v-row>
                                </v-card>

                                <v-card flat @click = "onRowClick(item)">
                                    <v-row class="no-frame pl-1"  v-if="item.filename">
                                        <v-col class="no-frame table-text col-2" style="padding-top: 2px;" >
                                           <div :class="item.error ? 'error doc-status' : item.status ? 'success doc-status' : ''">
                                               {{ date (item.executiondate) }}
                                           </div>
                                        </v-col>
                                        <v-col class="no-frame table-text v-flex" >
                                            <div class="lm-border mr-2 incident-button v-flex" v-if="item.incidentId ">
                                                <div style="margin-top: -2px">
                                                    <c-toolbar-button
                                                        icon="mdi-pen"
                                                        size="14"
                                                        color="primary"
                                                        tooltip="Ereignis bearbeiten"
                                                        @click="onIncident(item.incidentId)"
                                                    />
                                                </div>
                                                <div>
                                                    {{ item.incidentId }}
                                                </div>
                                            </div>
                                            <div class="w-100 v-flex" :class="document && document.id === item.id ? 'primary pl-1 pr-1 doc-status' : ''">
                                                <div style="padding-top: 1px;" :class="isIgnored (item) ? 'grey--text' : ''">
                                                    {{ item.hint? (item.hint + " - " + item.name ) : item.name}}
                                                </div>
                                                <v-spacer />
                                                <v-btn
                                                    v-if="isAssignable(item)"
                                                    @click="onAssign"
                                                    color="white"
                                                    class="mr-1"
                                                    x-small
                                                    style="margin-top: 2px"
                                                >
                                                    <v-icon color="warning" size="20">mdi-arrow-left-bold</v-icon>
                                                </v-btn>
                                                <v-btn
                                                    v-if="isDeleteable(item)"
                                                    @click="onDelete"
                                                    color="white"
                                                    x-small
                                                    style="margin-top: 2px"
                                                >
                                                    <v-icon color="error" size="20">mdi-delete</v-icon>
                                                </v-btn>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                         </template>
                    </v-treeview>
                </div>

                <div class="w-50">
                    <div class="w-100 lm-border pa-3 pb-2" style="height: 50%" v-if="isMaintenance && isElo(document)">
                        <div v-if="(document || dmsDocument) && !folder">
                            <v-progress-linear
                                indeterminate
                                color="primary"
                                height="8"
                            />

                            <div class="elo-dir-loading primary--text">
                                Die ELO Dokumente zur Anlage {{ unitId }} werden ermittelt ...
                            </div>
                        </div>
                        <c-dms-folder-info
                            class     = "h-100"
                            :folder   = "folder"
                            :selected = "dmsDocument"
                            :from     = "interval.from"
                            :to       = "interval.to"
                            @selected = "onDmsSelected"
                        />
                    </div>

                    <div
                        class="w-100 lm-border pa-3 "
                        :style="isMaintenance && isElo(document) ? 'height: calc(50% - 8px)' : 'height:100%'"
                        :class="isMaintenance && isElo(document) ? 'mt-2' : 'mt-0'"
                    >
                        <c-dms-viewer
                            v-if="(document && !document.id.startsWith('--')) || dmsDocument"
                            style="height: 100%"
                            :document = "selectedDocument"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Core              from "@/modules/core/service/Core";
import DocExport         from "@/modules/dms/export/service/DocExport";
import CAppBar           from "@/modules/core/components/app/CAppBar.vue";
import FEnumAutocomplete from "@/modules/core/components/utils/FEnumAutocomplete.vue";
import FDatePicker       from "@/modules/core/components/utils/FDatePicker.vue";
import CDmsViewer        from "@/modules/dms/viewer/CDmsViewer.vue";
import CColumnHeader     from "@/modules/core/components/utils/CColumnHeader.vue";
import CToolbarButton    from "@/modules/core/components/utils/CToolbarButton.vue";
import Inc from "@/modules/inc/service/Inc";
import CDmsFolderInfo from "@/modules/dms/info/components/CDmsFolderInfo.vue";

export default {
    name: "MDmsExport",

    components: {
        CDmsFolderInfo,
        CToolbarButton,
        CColumnHeader,
        CDmsViewer,
        FDatePicker,
        FEnumAutocomplete,
        CAppBar
    },

    data: () => ({
        /**
         * The selected customer
         */
        customer: null,

        /**
         * List of all and filtered documents
         */
        documents: {
            all: null,
            filtered: null,
        },

        /**
         * The document type to export
         */
        doctype: "Wartungsnachweis",

        /**
         * Tree view document
         */
        document: null,

        /**
         * DMS document in folder
         */
        dmsDocument: null,

        exporting: false,

        folder: null,
        unitId: null,
        search  : null,
        open    : [],
        interval: {
            from: '2023-01-01',
            to  : null
        },

        types: [
            "Prüfbericht",
            "Wartungsnachweis",
            "GBU",
            "Aufzugswärterprotokoll"
        ],

        gbuTypes: [
            "Budgetplanung",
            "ESG",
            "Gefährdungsbeurteilung",
            "Konzept zur Anpassung",
            "Soll-/Ist-Abgleich",
            "Zustandsbericht"
        ],

        gbuSelection: null,

        headers: [
            {
                text: 'Fabrik-Nr.',
                align: 'start',
                value: 'fabricNo',
                width: "80px"
            },
            {
                text: 'Ereignis',
                align: 'start',
                value: 'incidentId',
                width: "80px"
            },
            {
                text: 'Datum',
                value: 'executiondate',
                align: 'center',
                width: "90px"
            },
            {
                text: 'Datei',
                value: 'name',
                align: 'start',
                width: "250px"
            },
        ],
    }),

    computed: {
        selectedDocument () {
            if (this.dmsDocument) {
                return this.dmsDocument.guid;
            }

            if (!this.document) {
                return null;
            }

            return this.document.id;
        },

        isMaintenance () {
            return !this.doctype || this.doctype === 'Wartungsnachweis';
        }
    },

    mounted() {
        this.interval.to = Core.format.date.toJson(Core.format.today());
        this.gbuSelection = [];
        this.gbuTypes.forEach(t => {
            this.gbuSelection.push (t)
        })
    },

    watch: {
        search () {
            this.onFilter();
        }
    },

    methods: {
        onValidate () {
            this.dmsDocument = null;
            this.document    = null;

            if (!this.$refs.form.validate ()) {
                return;
            }

            DocExport.validate(this.customer.id, this.doctype, this.interval.from, this.interval.to).then((data) => {
                data.forEach (e => {
                   e.key = e.filename ? e.filename : e.fabricNo;
                });

                this.documents.all = data;
                this.onFilter();
            })
        },

        onFilter () {
            if (!this.search) {
                this.documents.filtered = this.documents.all;
                return;
            }

            this.documents.filtered = this.documents.all.filter(d => Core.filter.includes(d.fabricNo, this.search)
                || Core.filter.includes(d.zip, this.search)
                || Core.filter.includes(d.city, this.search)
                || Core.filter.includes(d.street, this.search))
            ;
        },

        async onExport () {
            if (!this.$refs.form.validate ()) {
                return;
            }

            if (!this.documents.filtered) {
                return;
            }

            this.exporting = true;
            this.onExpand();
            let txId = null;
            let dmsfolder;
            let dmsdocument;
            for (dmsfolder of this.documents.filtered) {
                for (dmsdocument of dmsfolder.entries) {
                    let valid = true;

                    if (this.doctype === 'GBU') {
                        if (!this.gbuSelection.find(t => dmsdocument.name.startsWith(t))) {
                            valid = false;
                        }
                    }

                    if (valid) {
                        dmsdocument.txId = txId;
                        await DocExport.process(this.customer.id, dmsdocument).then((data) => {
                            txId = data.txId;
                            dmsdocument.status = data.status;
                            dmsdocument.error  = data.error;
                        })
                    }
                }
            }

            if (txId) {
                DocExport.download(txId, (blob) => {
                    const link = document.createElement("a");
                    link.href =blob;
                    link.download = txId + ".zip";
                    link.click();
                }, () => {

                })
            }

            this.exporting = false;
        },

        onUnit (item) {
            console.log("onUnit ", item);
        },

        onRowClick (item) {
            this.dmsDocument = null;
            this.document = null;

            if (this.isElo(item)) {
                if (item.unitId !== this.unitId) {
                    this.unitId = item.unitId;
                    this.folder = null;
                    DocExport.folderinfo(item.eloUnitFolder).then((info) => {
                        this.folder = info;
                        this.dmsDocument = this.folder.entries.find(entry => entry.guid === item.id);
                        console.log("item", item, this.dmsDocument);
                    })
                } else {
                    this.dmsDocument = this.folder.entries.find(entry => entry.guid === item.id);
                }
            }

            this.document = item;
        },

        onExpand () {
            console.log("onExpand")
            if (!this.documents.filtered) {
                return;
            }

            this.open=[];
            this.documents.filtered.filter(d => !d.filename).forEach(d => this.open.push (d.key));
        },

        onIncident (incidentId) {
            console.log(incidentId)
            let route = this.$router.resolve({name: 'incident', params: {id: incidentId} });
            window.open(route.href, '_blank');
        },

        onDmsSelected (entry) {
            console.log("onDmsSelected", entry)
            if (!entry) {
                this.dmsDocument = null;
                return;
            }

            this.dmsDocument = entry;
        },

        onAssign () {
            Core.loading(this, true);
            DocExport.assign(this.unitId, this.document.stepdataId, this.dmsDocument, this.document).then((doc) => {
                this.document.id = doc.id;
                this.document.name = doc.name;
                Core.loading(this, false);
                Core.message.hint(this, "Dokument wurde zugeordnet");
            }).catch(() => {
                Core.loading(this, false);
            })
        },

        onDelete () {
            Core.message.confirm(
                this,
                this.$t("inc.delete.confirm.query"),
                this.$t("inc.delete.confirm.text"),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    Inc.delete(this.document.incidentId, () => {
                        Core.message.hint(this, "Das Ereignis wurde gelöscht");
                        this.onValidate()
                    });
                }
            );

        },

        onSearch () {

        },

        isDeleteable (item) {
            if (!item || !this.document ) {
                return false;
            }

            if (!this.document || item.id !== this.document.id) {
                return false;
            }

            return item && item.id.startsWith ("(") || item.id.startsWith ("--");
        },

        isAssignable (item) {
            if (!item || !this.document ) {
                return false;
            }

            if (item.id !== this.document.id) {
                return false;
            }

            if ((this.document && (this.document.id.startsWith ("(") || this.document.id.startsWith ("--")) && this.dmsDocument)) {
                return true;
            }

            return false;
        },

        isElo (item) {
            if (!item) {
                return false;
            }

            if ((item.id.startsWith ("(") || item.id.startsWith ("--"))) {
                return true;
            }

            return false;
        },

        isIgnored (item) {
            if (this.doctype !== 'GBU') {
                return false;
            }

            return !this.gbuSelection.find(t => item.name.startsWith(t));
        },

        customerRequiredRule (value) {
            return Core.rule.required(value);
        },

        date (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>

::v-deep .v-data-table__wrapper {
    overflow-x: hidden;
    overflow-y: hidden;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td, .v-data-table>.v-data-table__wrapper>table>tbody>tr>th, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td, .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th, .v-data-table>.v-data-table__wrapper>table>thead>tr>td, .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    padding: 0px 8px;
    transition: height .2s cubic-bezier(.4,0,.6,1);
}

.current-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.guid {
    font-size: 8px;
    margin-top: -2px;
}

::v-deep .theme--light.v-icon:focus:after {
    opacity: 0;
}

::v-deep .v-treeview--dense .v-treeview-node__root {
    min-height: 30px;
}

::v-deep .v-treeview-node__content {
    margin-left: 0;
}

.table-text {
    font-size: 14px;
    height: 26px;
}

.tool-button {
    padding-top: 2px;
    height: 35px;
    width: 100px;
    text-align: center;
    border-radius: 5px;
}

.incident-button {
    padding-top: 1px;
    height: 24px;
    width: 100px;
    text-align: center;
    border-radius: 4px;
}

::v-deep .doc-status {
    height: 24px;
    padding-top: 0px;
    border-radius: 4px;
    padding-left: 4px;
    margin-right: 4px;
    color: white;
}

.elo-dir-loading {
    text-align: center;
    font-size: 20px;
    padding-top: 100px;
    font-weight: 600;
}

</style>